// const BASE_URL = "http://localhost:3001/api/v1";
const BASE_URL = "https://backend.hairsncares.com/api/v1";

// const BASE_URL = 'https://hair-becken.vercel.app/api/v1'

export default BASE_URL;
